import { render, staticRenderFns } from "./Webphone.vue?vue&type=template&id=1a76d5a9"
import script from "./Webphone.vue?vue&type=script&lang=js"
export * from "./Webphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports